export default __webpack_public_path__ + "static/hookedonyou-logo-large-e98fdbeda5aa122f42ebd9a61390f199.svg";